<template>
    <div class="na-form">
        <div v-if="post" class="left">
            <DxTabPanel>
                <DxItem title="Basisdaten">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='post.NevId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Description:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='post.NevDescription' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Template Enabled:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='post.NevEnabled' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Sender:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevSender' />
                            </div>
                        </div>          
                        <div class="dx-field">
                            <div class="dx-field-label">Cc Receiver:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevCcReceiver' />
                            </div>
                        </div>     
                        <div class="dx-field">
                            <div class="dx-field-label">BCc Receiver:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevBccReceiver' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Receiver:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="NroName" :dataSource="notificationReceiver" valueExpr="NroId"
                                             showClearButton="true" v-model:value="post.NroId" />
                            </div>
                        </div>
                        <div class="dx-field" v-if="post.NroId==4">
                            <div class="dx-field-label">Send to Email:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevReceiver' />
                            </div>
                        </div>
                        <div class="dx-field" v-if="post.NroId==7">
                            <div class="dx-field-label">Send to Specific User:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="userList"
                                             :show-clear-button="true"
                                             display-expr="UsrFullName"
                                             value-expr="UsrId"
                                             :search-enabled="true"
                                             placeholder="Choose User"
                                             v-model:value="post.UsrId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="post.NroId==6 || post.NroId==9">
                            <div class="dx-field-label">
                                <span v-if="post.NroId==6">
                                    Send to All Users of Group:
                                </span>
                                <span v-if="post.NroId==9">
                                    Select Experts From Group:
                                </span>
                            </div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="groupList"
                                             :show-clear-button="true"
                                             display-expr="GrpName"
                                             value-expr="GrpId"
                                             :search-enabled="true"
                                             placeholder="Choose Group"
                                             v-model:value="post.GrpId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Subject:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='post.NevTemplateSubject' />
                            </div>
                        </div>
                        <div class="dx-field ">
                            <div class="dx-field-label html-label">Body:</div>
                            <DxHtmlEditor class="html-dx-field"
                                          v-model:value="post.NevTemplateBody">
                                <DxVariables :data-source="editorVariables"
                                             :escape-char="escapeCharacters" />
                                <DxToolbar :items="toolBarItems">
                                </DxToolbar>
                            </DxHtmlEditor>


                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label html-label">
                                Footer:
                            </div>
                            <DxHtmlEditor v-model:value="post.NevFooter"
                                          :height="200" class="html-dx-field">
                                <DxVariables :data-source="editorVariables"
                                             :escape-char="escapeCharacters" />
                                <DxToolbar :items="toolBarItems"></DxToolbar>
                            </DxHtmlEditor>


                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Created by:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='post.NevCreatedBy' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Created on:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='post.NevCreatedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed by:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='post.NevChangedBy' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Changed on:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='post.NevChangedOn' :readOnly="true" />
                            </div>

                        </div>



                        <div class="na-buttons-row">

                            <div>
                                <DxButton text="Save"
                                          type="default"
                                          styling-mode="contained"
                                          @click="onSaveClick()"
                                          onmouseover="this.style.backgroundColor='#006db9'" />
                            </div>
                            <!--<div>
                                <DxButton text="Create Script"
                                          type="default"
                                          styling-mode="outlined"
                                          @click="onClick($event)" />
                            </div>-->
                            <div>
                                <DxButton text="Close"
                                          type="default"
                                          styling-mode="outlined"
                                          @click="onCloseClick()" />
                            </div>

                            <div>
                            </div>


                        </div>
                    </div>
                </DxItem>
            </DxTabPanel>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox, DxTextArea } from 'devextreme-vue';
    import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel'
    import { DxButton } from 'devextreme-vue/button';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import '../assets/detailForm.less';
    import { alert } from "devextreme/ui/dialog"
    //import { nextTick } from 'vue'
    import $ from 'jquery';
    import {
        DxHtmlEditor,
        DxToolbar,
        DxVariables
    } from 'devextreme-vue/html-editor';

    const baseUri = "WebApi.asmx/api/NotificationEventListService";
    export default {
        name: 'NotificationEventDetailVx',
        components: {
            DxButton,
            DxTextBox,
            DxTextArea,
            DxDateBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            DxTabPanel,
            DxCheckBox,
            DxSelectBox,
            DxVariables
        },
        data() {
            return {
                post: null,
                notificationReceiver: [],
                files: [],
                editorVariables: ["UsrFirstName", "UsrLastName",
                    "Owner_UsrFirstName", "Owner_UsrLastName",
                    "Assignee_UsrFirstName", "Assignee_UsrLastName",
                    "LinkOwner_UsrFirstName", "LinkOwner_UsrLastName",
                    "LinkAssignee_UsrFirstName", "LinkAssignee_UsrLastName",
                    "CurrentUser_UsrFirstName", "CurrentUser_UsrLastName",
                    "LinkTopic1_Title", "LinkTopic2_Title",
                    "ID", "Title", "Description",
                    "TopicLink", "LinkedTopic1Link", "LinkedTopic2Link",
                    "TdgText001", "TdgText002", "TdgText003", "TdgText004", "TdgText005",
                    "TdgMemo001", "TdgMemo002", "TdgMemo003", "TdgMemo004", "TdgMemo005"],
                escapeCharacters: ['{', '}']
            };
        },
        computed: {
            toolBarItems() {
                return this.$store.state.htmlEditorStore.toolBarItems;
            },
            userList() {
                return this.$store.state.userStore.userList
            },
            groupList() {
                return this.$store.state.groupStore.groupListSimple
            },
        },
        created: function () {
            this.$store.dispatch("getUserList");
            this.$store.dispatch("getGroupListSimple");
            axios
                .get(baseUri + '/GetDetail')
                .then(res => {
                    this.post = res.data.data;

                })
            axios
                .get(baseUri + '/GetNotificationReceiverSimple')
                .then(res => {
                    this.notificationReceiver = res.data.data.filter(m => { return m.NroId != 3 });

                })
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                setTimeout(() => {
                    var formData = new FormData()
                    formData.append("data", JSON.stringify(this.post))
                    axios
                        .post(baseUri + '/SaveDetail', formData)
                        .then(res => {
                            if (res.data.success) { notify(`The changes were saved successfully`); }
                            else { alert(`error: ${res.data.errorMessage}`) }

                        });
                }, 500)
            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style scoped>
    .dx-field {
        display: grid;
    }

    .dx-field-value-static, .dx-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
        width: auto;
    }
</style>
